const host = "https://tfu7qmnukd.execute-api.eu-north-1.amazonaws.com";
const externalHost = "https://demo.svenskafribrevsbolaget.se";
export default {
  env: "staging",
  domain: host,
  BASE_URL: `${host}/staging/`,
  S3_BASE_URL: "https://sfb-app-fs.s3.eu-north-1.amazonaws.com/",
  EXTERNAL_URL: externalHost,
  baseName: "/",
  language: "sv",
  markerDestinationId: "656ca9f7406b387c025517e7",
  sentryURL:
    "https://6ca6fff420f64cbc8b151fc084c428f9@o151669.ingest.sentry.io/5811616",
  api: {
    maxAge: 15 * 60 * 1000, // 15 minutes
  },
};
